export default {
  saved: "Data was successfully saved",
  updated: "Data was successfully updated",
  deleted: "Data was successfully deleted",
  sent: "Request was successfully sent",
  error: "System error - Please contact the administrator",
  assets: {
    createdToastMessage: "Asset has been created",
    updatedToastMessage: "Asset has been updated",
    deletedToastMessage: "Asset has been deleted",
    tagsUpdatedToastMessage: "Asset tags have been updated",
    types: {
      createdToastMessage: "Asset type has been created",
      updatedToastMessage: "Asset type has been updated",
      deletedToastMessage: "Asset type has been deleted",
      models: {
        createdToastMessage: "Asset model has been created",
        updatedToastMessage: "Asset model has been updated",
        deletedToastMessage: "Asset model has been deleted",
      },
    },
    attributeSets: {
      createdToastMessage: "Attribute set has been created",
      updatedToastMessage: "Attribute set has been updated",
      deletedToastMessage: "Attribute set has been deleted",
      attributes: {
        createdToastMessage: "Asset Attribute has been created",
        updatedToastMessage: "Asset Attribute has been updated",
        deletedToastMessage: "Asset Attribute has been deleted",
      },
    },
  },
  devices: {
    createdToastMessage: "Device has been created",
    activatedToastMessage: "Device activation token has been submitted",
    updatedToastMessage: "Device has been updated",
    deletedToastMessage: "Device has been deleted",
    tagsUpdatedToastMessage: "Device tags have been updated",
    deploymentGroups: {
      createdToastMessage: "Deployment group has been created",
      updatedToastMessage: "Deployment group has been updated",
      deletedToastMessage: "Deployment group has been deleted",
      addOrRemoveDevices: { devicesUpdatedToastMessage: "Deployment group devices have been updated" },
      iotApps: {
        appAddedToastMessage: "App has been added to the deployment group",
        appRemovedToastMessage: "App has been removed from the deployment group",
        appVersionUpdatedToastMessage: "App version of the deployment group has been updated",
      },
      admins: {
        coAdminAddedToastMessage: "Co-admin has been added",
        coAdminRemovedToastMessage: "Co-admin has been removed",
        coAdminTransferredToastMessage: "Deployment group rights have been transferred",
      },
    },
    sharedDeviceModels: {
      deviceModelSharedToastMessage: "Device model shared successfully",
    },
  },
  apps: {
    descriptionUpdatedToastMessage: "App description has been updated",
    sharedGloballyToastMessage: "App has been shared to all tenants",
    sharedGloballyErrorToastMessage: "Failed to share app. Please try again.",
    ratingUpdatedToastMessage: "App rating has been updated",
    softwareToReview: {
      appsPendingReview: {
        appReviewSubmittedToastMessage: "App review has been submitted",
      },
    },
  },
  userManagement: {
    roleCreatedToastMessage: "Role has been created",
    userRolesUpdatedToastMessage: "User roles have been updated",
  },
};
